/**
 * name: common.js
 * description: 전역으로 사용될 공통 함수 정의
 */

// ## 팝업 오픈 함수
export function BrowserPopup(popUrl, popWidth, popHeight, resizeyn) {
  const winHeight = window.screen.availHeight; // 현재창의 높이
  const winWidth = document.body.clientWidth; // 현재창의 너비
  const winX = window.screenX || window.screenLeft || 0; // 현재창의 x좌표
  const winY = window.screenY || window.screenTop || 0; // 현재창의 y좌표

  const popX = winX + (winWidth - popWidth) / 2;
  const popY = winY + (winHeight - popHeight) / 2;

  const rn = Math.round(Math.random() * 100);
  const popName = `popup${rn}`;

  let strResize = 'yes';
  if (resizeyn !== undefined) {
    strResize = resizeyn;
  }

  window.open(popUrl, popName, `width=${popWidth}px,height=${popHeight}px,top=${popY},left=${popX},toolbar=no, menubar=no, scrollbars=yes, resizable=${strResize}`);
}

// ## 뷰티플래너 오픈 함수
export function openBeautyPlanner() {
  BrowserPopup('https://www.incellderm.com/popup/popup_search.asp', 520, 380);
}

// ## Custom 로그 출력 함수
export function log(ctx, ...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`%c[${ctx}]`, 'color:#008fc5', ...args);
  }
}

export function moveToUrlOfTargetType(that, targetType, url) {
  switch (targetType) {
    case 'NEW_WINDOW':
      // 새창
      window.open(url);
      break;
    case 'CURRENT_WINDOW':
      that.$router.push({ path: url });
      break;
    case 'NONE':
      break;
    default:
      console.warn('Invalid link type.');
  }
}

export default {
  log,
  openBeautyPlanner,
  moveToUrlOfTargetType,
};
